import React from "react";
import { CreditCard, FileText } from "lucide-react";

const OPTIONS = [
  { type: "icon", icon: CreditCard, label: "Platba kartou" },
  { type: "icon", icon: FileText, label: "Faktura na firmu" },
  { type: "logo", src: "/brand/ccs-logo.svg", label: "CCS karta" },
];

export const TopBar = () => {
  return (
    <div
      data-testid="top-payment-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-black/85 backdrop-blur-xl border-b border-[#D4AF37]/20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 h-10 sm:h-11 flex items-center justify-center sm:justify-between gap-4 overflow-hidden">
        <div className="hidden md:block text-[10px] tracking-[0.35em] uppercase text-[#D4AF37]/80 whitespace-nowrap">
          Možnosti platby
        </div>

        <div className="flex items-center gap-3 sm:gap-5 md:gap-7 overflow-x-auto no-scrollbar">
          {OPTIONS.map((o) => {
            if (o.type === "logo") {
              return (
                <div
                  key={o.label}
                  data-testid="payment-option-ccs-karta"
                  className="flex items-center gap-2 whitespace-nowrap"
                >
                  <span className="inline-flex items-center justify-center bg-white px-1.5 py-0.5 rounded-sm shadow-sm">
                    <img
                      src={o.src}
                      alt="CCS — Karta CCS"
                      width="36"
                      height="24"
                      className="h-[16px] sm:h-[18px] w-auto"
                      loading="eager"
                      decoding="async"
                    />
                  </span>
                  <span className="text-[10px] sm:text-[11px] tracking-[0.18em] sm:tracking-[0.22em] uppercase text-zinc-300">
                    Karta CCS
                  </span>
                </div>
              );
            }
            const Icon = o.icon;
            return (
              <div
                key={o.label}
                data-testid={`payment-option-${o.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-1.5 sm:gap-2 text-zinc-300 whitespace-nowrap"
              >
                <Icon size={13} strokeWidth={1.4} className="text-[#D4AF37] shrink-0" />
                <span className="text-[10px] sm:text-[11px] tracking-[0.18em] sm:tracking-[0.22em] uppercase">
                  {o.label}
                </span>
              </div>
            );
          })}
        </div>

        <div className="hidden md:block text-[10px] tracking-[0.3em] uppercase text-zinc-500 whitespace-nowrap">
          Pro firmy i jednotlivce
        </div>
      </div>
    </div>
  );
};

export default TopBar;
